import React, { useRef } from 'react'
import { Dialog, DialogProps, styled } from '@mui/material'
import useOutsideClick from './useOutsideClick'
import { useConfirmationDialogKeyboard } from './useConfirmationDialogKeyboard'

const StyledDialog = styled(Dialog)({
    pointerEvents: 'none',
    '& .MuiDialog-paper': {
        pointerEvents: 'auto',
    },
})

export type CustomDialogProps = DialogProps & {
    onEnterSubmit?: () => void
    enterSubmitDisabled?: boolean
}

const CustomDialog: React.FC<CustomDialogProps> = ({
    children,
    onClose,
    open,
    onEnterSubmit,
    enterSubmitDisabled,
    ...dialogProps
}) => {
    const wrapperRef = useRef<HTMLDivElement>(null)

    useOutsideClick(wrapperRef, () => {
        if (open) {
            onClose?.(null as any, 'backdropClick')
        }
    })

    useConfirmationDialogKeyboard(Boolean(open), {
        onSubmit: onEnterSubmit,
        onClose: onClose ? () => onClose(null as any, 'escapeKeyDown') : undefined,
        submitDisabled: enterSubmitDisabled,
    })

    return (
        <StyledDialog
            {...dialogProps}
            open={open}
            onClose={onClose}
            hideBackdrop
            disableScrollLock
            disableEnforceFocus
            disableAutoFocus
            disableRestoreFocus
        >
            <div ref={wrapperRef}>{children}</div>
        </StyledDialog>
    )
}

export default CustomDialog
